// extracted by mini-css-extract-plugin
module.exports = {"BundlesCommon":"TabBundles_BundlesCommon__iTEJX","BundlesCommon2":"TabBundles_BundlesCommon2__ikHeD","BundlesCommonJp":"TabBundles_BundlesCommonJp__GWHBi"};